import { WidthContainer } from '@pata-app/ui-document';

import React, { Fragment } from 'react';

import { getEnv } from '../../../../lib/utils/getEnv';
import Faq from './components/faq';
import { faqsConfig } from './faq.config';
import { FaqsContainer, FaqsSection, HelpCentreLink } from './faqs.styled';

const { VITE_HELP_CENTRE_URL } = getEnv();

const Faqs = () => {
  return (
    <WidthContainer>
      <FaqsSection id="faq">
        <h2>
          <span>Have you got questions about the Pata booking software?</span>

          <span>
            We’ve got the <span>answers</span>.
          </span>
        </h2>
        <div>
          <FaqsContainer>
            {faqsConfig.map((faq, index) => (
              <Fragment key={faq.question}>
                <Faq question={faq.question} answer={faq.answer} />
                {index + 1 < faqsConfig.length && <hr />}
              </Fragment>
            ))}
          </FaqsContainer>

          <HelpCentreLink>
            Still have questions? Visit our{' '}
            <a href={`${VITE_HELP_CENTRE_URL}`} target="_blank">
              {' '}
              Help Centre{' '}
            </a>
            for more detailed information or email <a href={'mailto:business@pata.pet'}>business@pata.pet</a>.
          </HelpCentreLink>
        </div>
      </FaqsSection>
    </WidthContainer>
  );
};

export default Faqs;
